import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import type { ItsOneViewFinancialItem } from "@/types/its-one-view";
import { openItsOneViewLink } from "@/utils/its-one-view-links";
import { formatInr, formatShortDate } from "../format-inr";

type FinancialTableProps = {
  items: ItsOneViewFinancialItem[];
  showPaidTill?: boolean;
};

export default function FinancialTable({ items, showPaidTill }: FinancialTableProps) {
  if (items.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No records found for this household.
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Details</TableCell>
            <TableCell>ITS</TableCell>
            <TableCell align="right">Paid</TableCell>
            <TableCell align="right">Pending</TableCell>
            {showPaidTill ? <TableCell>Paid till</TableCell> : null}
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell>
                <Typography variant="body2">{row.label}</Typography>
                {row.memberName ? (
                  <Typography variant="caption" color="text.secondary">
                    {row.memberName}
                  </Typography>
                ) : null}
              </TableCell>
              <TableCell>{row.itsNo ?? "—"}</TableCell>
              <TableCell align="right">{formatInr(row.paidAmount)}</TableCell>
              <TableCell align="right">
                {row.pendingAmount != null && row.pendingAmount > 0 ? (
                  <Chip label={formatInr(row.pendingAmount)} size="small" color="warning" />
                ) : (
                  "—"
                )}
              </TableCell>
              {showPaidTill ? <TableCell>{formatShortDate(row.paidTill)}</TableCell> : null}
              <TableCell align="right">
                <Button
                  size="small"
                  endIcon={<OpenInNewIcon />}
                  onClick={() => openItsOneViewLink(row.link)}
                >
                  Open
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
